/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Challenge_Finding_TimeInputs */

const en_onboarding_challenge_finding_time = /** @type {(inputs: Onboarding_Challenge_Finding_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finding time to read`)
};

const es_onboarding_challenge_finding_time = /** @type {(inputs: Onboarding_Challenge_Finding_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontrar tiempo para leer`)
};

/**
* | output |
* | --- |
* | "Finding time to read" |
*
* @param {Onboarding_Challenge_Finding_TimeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_challenge_finding_time = /** @type {((inputs?: Onboarding_Challenge_Finding_TimeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Challenge_Finding_TimeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_challenge_finding_time(inputs)
	return en_onboarding_challenge_finding_time(inputs)
});